import {getStoreDataPending, getStoreDataSuccess, getStoreDataError} from './index';
import config from '../../oktaConfig';

function getStoreData(accessToken) {
  return dispatch => {
    dispatch(getStoreDataPending());

    fetch(config.resourceServer.insightsApiUrlStores + `?tradingstatus=3`, {
      mode: 'cors',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then(response => {
        if (!response.ok) {
          // console.log('Redux response', response);
          return Promise.reject();
        }
        return response.json();
      })
      .then(data => {
        // console.log('Redux data', data);
        dispatch(getStoreDataSuccess(data));
      })
      .catch(err => {
        console.log('Redux err', err);
        dispatch(getStoreDataError(err));
        /* eslint-disable no-console */
        console.error(err);
      });
  };
}

export default getStoreData;
